const formatNumber = (q: any) => {
    return q.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL'

    })
   } 

   export default formatNumber;